import { useCallback } from 'react';
import { useLogger } from '@ids/appshell';

const useSessionStorage = () => {
    const logger = useLogger();

    const getItem = useCallback(
        (key: string) => {
            if (typeof window.sessionStorage === 'undefined') {
                return null;
            }

            const storedValue = window.sessionStorage.getItem(key) || 'null';

            try {
                return JSON.parse(storedValue);
            } catch (error) {
                logger.error(String(error));
            }

            return storedValue;
        },
        [logger]
    );

    const setItem = useCallback((key: string, value: unknown) => {
        if (typeof window.sessionStorage === 'undefined') {
            return null;
        }

        return window.sessionStorage.setItem(key, JSON.stringify(value));
    }, []);

    const deleteItem = useCallback((key: string) => {
        if (typeof window.sessionStorage === 'undefined') {
            return null;
        }

        return window.sessionStorage.removeItem(key);
    }, []);

    return {
        getItem,
        getSessionStorageItem: getItem,
        setItem,
        setSessionStorageItem: setItem,
        deleteItem,
        deleteSessionStorageItem: deleteItem,
    };
};

export default useSessionStorage;
